import React from 'react';
import SvgIcon from 'react-icons-kit';
import styled from 'styled-components';

const Button = styled.button`
    --padding: 0.25em;
    background: none;
    border: none;
    border-radius: 50%;
    /* box-shadow: ${props => props.highlight ? '0.25em 0.25em 0.5em var(--danger)' : 'none' }; */
    padding-inline: var(--padding);
    position: relative;

    & i > svg {
        height: ${props => props.size === 'lg' ? "3em" : props.size === 'md' ? "1.75em" : "1em" };
        width: ${props => props.size === 'lg' ? "3em" : props.size === 'md' ? "1.75em" : "1em" };
    }

    & i:not([class]) > svg {
        color: ${props => props.fill === 'default' ? 'var(--color-no-data-icon)' 
            : props.fill === 'no-data' ? 'var(--color-no-data)'
            : props.fill === 'partial-data' ? 'var(--color-partial-data)'
            : props.fill === 'data' ? 'var(--color-data)' : 'black'
        };
        transition: ease-in 150ms transform;
    }

    & i[class='highlight'] {
        position: absolute;
        bottom: calc(-1* calc(var(--padding)/3));
        right: 0;
    }

    & i[class='highlight'] > svg {
        color: rgba(255, 0, 0, 0.3);
        filter: blur(0.1em);
    }

    :disabled {
        cursor: not-allowed;
    }

    :hover i:not([class]) > svg {
        transform: ${props => props.disabled ? 'none' :'scale(1.1)'};
    }
`;

const FlatButton = (props) => (
    <Button
        disabled={props.disabled}
        fill={props.fill}
        highlight={props.highlight}
        onClick={(e) => props.action(e, props.variables)}
        title={props.title}
        size={props.size}
        name={props.name}
        style={props.styles}
    >
        <div className='center'>
            {props.highlight &&
                <SvgIcon icon={props.icon} className='highlight'  />
            }
            <SvgIcon icon={props.icon} />
        </div>
        {props.text !== '' &&
            props.text
        }
    </Button>
)
 
export default FlatButton;

FlatButton.defaultProps = {
    disabled: false,
    fill: '',
    highlight: false,
    size: 'md',
    variables: '',
    name:'',
    id:'',
    text:'',
    styles:{margin:5}
}